<template>
  <div >


    <!--<div style="position: relative; z-index: -1" width="100%">-->
      <!--<v-img src="../assets/images/content/math.png"  ></v-img>-->
    <!--</div>-->

    <Section background="white"  class="image-bg"
             :style="{'background-image': `url(${require('../assets/images/content/iStock-870849902-25percent.png')})`}"
    >

      <nav-bar></nav-bar>
      <div class=" main-heading heading-line">


        <v-container>
          <v-row justify="center">
            <v-col cols="12" sm="10" justify="center">
              <div class="center display-2">Better Living Endoscopy Center</div>
              <div class="center title">Gastroenterology and Internal Medicine</div>

              <v-btn x-large href="tel:6016389800" color="accent" class="text--primary mt-9" >Call 601-638-9800<br>For an Appointment</v-btn>
              <!--<v-btn x-large to="/contact" color="accent" class="text&#45;&#45;primary mt-9" >Request Appointment</v-btn>-->

            </v-col>
            <v-col grow></v-col>
          </v-row>
        </v-container>

      </div>
    </Section>








    <!-------------------------------location info----------------------------------------------------------------->

    <Section background="white">
      <div class="section">

        <div class="heading">
          Office Location
          <div class="mydivider" style="max-width: 230px;"></div>
        </div>

        <location></location>
      </div>
    </Section>









    <!--&lt;!&ndash;-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;contact us&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
    <!--<Section background="black" class="pt-10">-->

        <!--<v-container fluid  style="max-width: 1000px">-->
          <!--<v-row  justify="center" align="center">-->
            <!--<v-col cols="12" md="6" align="center" >-->

              <!--<div style="text-align: left">-->
                <!--<p style="font-size: 1.5em">Want to learn how the Espy Data Science team can help?   </p>-->

                <!--<p style="font-size: 1.5em">Just drop us a note-->
                  <!--and we'll get back to you as soon as we can.</p>-->


                <!--<p style="font-size: 1.5em">Thanks!</p>-->
              <!--</div>-->





            <!--</v-col>-->


            <!--<v-col cols="12" md="6" align="center">-->
              <!--<Contact></Contact>-->

            <!--</v-col>-->
          <!--</v-row>-->
        <!--</v-container>-->


    <!--</Section>-->








  </div>

</template>






<style scoped lang="scss">


  .image-bg{
    background-size: cover;
    background-position: center;
  }

  .main-heading{
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    /*background-image: url('../assets/images/content/math.png')*/

    background-size: cover;
    /*background-size: auto 100%;*/
    /*background-size: 100% auto;*/
    background-position: center;
    }

  .process-section{
    height: 700px;
    text-align: justify;

  }
  .heading-line{
    text-align: center;

  }


  .bg-transparent-light{
    background: rgba(255, 255, 255, 0.05);
    width:100%;
    padding-top: 50px;
    padding-bottom: 50px;

  }


  .section-heading{
    font-size: 3em;
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;

  }


  .section-sub-heading {
    font-size: 2em;
    font-weight: normal;
  }



  .container-services{
    max-width: 1200px;
    text-align: center;


    /*.service-heading{*/
      /*font-size: 2em;*/
      /*font-weight: normal;*/
    /*}*/



    .service-text{
      font-size: 1.0em;
      /*font-weight: lighter;*/
      line-height: 110%;
      text-align: justify;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .colored-icon-text{
    font-size: 1.4em;
    /*font-size: 1.0em;*/
    /*text-align: left;*/
    text-align: justify;
    max-width: 800px;
  }



  .mydivider{
    height: 1.5px;
    background: #aaaaaa;
    margin: auto;

    /*width: 400px;*/
    box-shadow: 2px 2px 4px #afafaf;

  }



  .section{
    width: 100%;
    min-height: 500px;
    /*background-color: #f1f1f1;*/
    padding-top: 50px;
    padding-bottom: 50px;

    .heading {
      text-align: center;
      font-size: 2.4em;
      padding-bottom: 30px;
    }



    .content-image{
      img{
        width: 100%;
        box-shadow: 2px 2px 8px #a8a8a8;
      }
    }

    .content-text{
      max-width: 700px;
      text-align: justify;
      font-size: 1.3em;
    }
  }







  .location{

    .heading-location{
      font-size: 1.2em;
      font-weight: bold;
      color: gray;

    }
    .text-location{
      font-size: 1em;
      padding-left: 10px;
    }

  }






















  .slide-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;
  }

  .slide-content{
    margin: auto;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 700px;

  }
  .slide-spacer{
    flex: 'flex-grow';
  }







</style>


<script>
// @ is an alias to /src
import location from '@/components/location.vue'
import navBar from '@/components/navBar.vue'
import Section from '@/components/Section.vue'

export default {
  name: 'home',
  components: {navBar, Section, location},
   data(){return {
      slides: [
         {
            title: 'MagnetiQ Brands Agency',
            content: 'I Regret every dollar spent on every analytics vendor other than Espy Data Science.',
            author: 'DJ, Owner'
         },
         {
            title: 'Ping Bear Studios',
            content: 'The Espy team helped automate our social media marketing and cut our campaign deployment time by 80%.',
            author: 'Anthony, CEO'
         },

         {
            title: 'DealerKnows Training',
            content: 'The guys at Espy Data Science built a custom app for us under a very tight deadline and did a great job.  ' +
               'I look forward to working with them on future projects.',
            author: 'Bill, Founder'
         },

      ]
   }},
   computed:{
     slide_ratio(){

        if (['xs'].includes(this.$vuetify.breakpoint.name)){
           return 0.7;
        }

        else if (['sm'].includes(this.$vuetify.breakpoint.name)){
           return 0.5;
        }
        else {
           return 0.3;
        }
     }
   }


}
</script>
